import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";

const Alumni = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "Proud Alumni", path: "proud-alumni" },
    // { name: "Alumni Registration Form", path: "alumni-registration" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name || "Alumni";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "proud-alumni": {
      title: "Proud Alumni",
      bgImage: "/assets/images/inner_bnr/DSC_1287.webp",
    },

    // "alumni-registration": {
    //   title: "Alumni Registration Form",
    //   bgImage: "/assets/images/inner_bnr/pexels.jpg",
    // },
  };

  //  Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key),
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "Alumni",
        bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  console.log("welcome");
  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Alumni;
